import { Action } from "redux";
import { IMatchingQueuePagedResult, IMatchingSearchResult } from "./business-objects/common";
import { IWorkflowItemStep } from "../../../common/sharedTypes";

export interface IMatchingQueueState {
  results: IMatchingSearchResult[];
  pagedResults: IMatchingQueuePagedResult[];
  openWorkflowItemStep: IWorkflowItemStep;
  loadingWorkflowSteps: boolean;
  totalWorkflowItemSteps: number;
}

// ACTIONS
export interface IMatchingQueueAction extends Action {
  type: "@@dataentryqueue/SEARCH_PARTIAL_MATCHES";
  payload: {};
}

export enum MatchingQueueActionTypes {
  SEARCH_PARTIAL_MATCHES = "@@matchqueue/SEARCH_PARTIAL_MATCHES",
  SEARCH_PARTIAL_MATCHES_PAGED = "@@matchqueue/SEARCH_PARSEARCH_PARTIAL_MATCHES_PAGEDTIAL_MATCHES",
  OPEN_REPORT = "@@matchqueue/OPEN_REPORT",
  ASSIGN_AND_OPEN_REPORT = "@@matchqueue/ASSIGN_AND_OPEN_REPORT",
  CANCEL_MERGE = "@@matchqueue/CANCEL_MERGE",
  UNASSIGN = "@@matchqueue/UNASSIGN",
  MARK_AS_NEW = "@@matchqueue/MARK_AS_NEW",
  COMPLETE_MERGE = "@@matchqueue/COMPLETE_MERGE",
  SEND_TO_MANAGEMENT = "@@matchqueue/SEND_TO_MANAGEMENT",
  LOADING_WORKFLOW_STEPS = "@@matchqueue/LOADING_WORKFLOW_STEPS",
  TOTAL_WORKFLOW_STEPS = "@@matchqueue/TOTAL_WORKFLOW_STEPS",
}

export type MatchingQueueActions = IMatchingQueueAction;
